/**
 * @fileoverview A component that provides a loader for the study.
 * It uses the `react-router-dom` library to navigate to the first study.
 *
 * @example
 * <StudyLoader />
 */

import { Navigate } from 'react-router-dom'
import { useGetStudiesQuery } from '../services/studies'

/**
 * In the case if there is no study id provided, we need to fetch
 * a list of studies and redirect to the first one.
 *
 * This functionality is used for the Rater flow, see router.tsx
 */

/**
 * @function StudyLoader
 * @description Component for loading the study.
 * @returns {JSX.Element | null} - The StudyLoader component.
 */
export function StudyLoader() {
    const { data: studies } = useGetStudiesQuery()

    // TODO: Handle the case when there are no studies
    if (studies.length === 0) {
        return null
    }

    return <Navigate to={`/app/study/${studies[0]?.id}`} replace />
}
